"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DndList = exports.useDndList = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _withTheme = require("../../wrappers/with-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var id = -1;

var makeId = function makeId() {
  return "list-".concat(++id);
};

var DraggableItem = function DraggableItem(_ref) {
  var id = _ref.id,
      index = _ref.index,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
    draggableId: "draggable-".concat(id),
    index: index
  }, function (provided) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps), children);
  });
};

var useDndList = function useDndList(items, setItems) {
  var onDrop = _react["default"].useCallback(function (start, end) {
    var _items$splice = items.splice(start, 1),
        _items$splice2 = _slicedToArray(_items$splice, 1),
        item = _items$splice2[0];

    items.splice(end, 0, item);
    setItems(_toConsumableArray(items));
  }, [items, setItems]);

  return onDrop;
};

exports.useDndList = useDndList;

var DndList = function DndList(_ref2) {
  var onDrop = _ref2.onDrop,
      children = _ref2.children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? "" : _ref2$className;

  var onDragEnd = _react["default"].useCallback(function (result) {
    if (!result.destination) return;
    var start = result.source.index,
        end = result.destination.index;
    if (start === end) return;
    onDrop(start, end);
  }, [onDrop]);

  var theme = (0, _withTheme.useTheme)();
  return !_react["default"].Children.toArray(children).length ? null : /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: makeId(),
    className: "box-content"
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      ref: provided.innerRef
    }, provided.droppableProps, {
      className: "flex flex-col\n                ".concat(snapshot.isDraggingOver ? theme.listDragging : theme.list, "\n                ").concat(className, "\n              ")
    }), _react["default"].Children.toArray(children).map(function (child, i) {
      return /*#__PURE__*/_react["default"].createElement(DraggableItem, {
        key: child.key,
        id: child.key,
        index: i
      }, child);
    }), provided.placeholder);
  }));
};

exports.DndList = DndList;
DndList.defaultProps = {
  items: [],
  idAccessor: function idAccessor(d) {
    return d.id;
  },
  indexAccessor: function indexAccessor(d) {
    return d.index;
  },
  onDrop: function onDrop(start, end) {}
};